import { useEffect } from "react"
import { getCookies } from "cookies-next"
import { getPageData } from "services/craft/craft"
import runMiddleware from "lib/runMiddleware"
import Layout from "components/layout/layout"
import darkLightPageStyles from "styles/darkLightStyles"

export default function Page(props) {
    // send version param to GTM/GA
    useEffect(() => {
        if (!props.version) return
        window.dataLayer.push({
            crf_page_version: props.version,
        })
        window.dataLayer.push({
            event: "crf_pageview",
        })
    }, [props.version])

    // an ad set on the page overrides the global site ad
    const pageAd = props.page.leaderboardAd.length ? props.page.leaderboardAd[0].adUnit : null

    const colorMode = props.page.colorMode || "dark"

    let pageBackground = darkLightPageStyles[colorMode].bgColor
    const bgStyles = {}
    if (props.page.pageBackgroundMedia && props.page.pageBackgroundMedia[0]?.url) {
        pageBackground += " url(" + props.page.pageBackgroundMedia[0]?.url + ")"
        bgStyles.backgroundSize = "cover"
        bgStyles.backgroundPosition = "center center"
    }

    return (
        <Layout
            className={"colorMode--" + colorMode + " page--htmlPage page--" + props.slug}
            bg={pageBackground}
            bgStyles={bgStyles}
            site={props.site}
            page={props.page}
            slug={props.slug}
            pageAd={pageAd}
            matrix={props.page.matrix}
            user={props.user}
            colorMode={colorMode}
            channels={props.channels}
            craftSiteId={props.site.meeting.siteId}
            layoutVariant={props.layoutVariant}
        />
    )
}

export const getServerSideProps = runMiddleware(async function (ctx) {
    const user = ctx.user
    const cookies = getCookies({ req: ctx.req, res: ctx.res })
    const pageSlug = ctx.params.slug[0]

    if (cookies?.layout === "app") {
        ctx.req.layout = "app"
    }

    const data = await getPageData({
        locale: ctx.locale,
        page: {
            slug: pageSlug,
        },
        query: ctx.query,
    })

    // page/slug not found, return 404
    if (!data.page) {
        return {
            notFound: true,
        }
    }

    // if the page is disabled, temporarily redirect to the homepage
    if (data.page.status === "disabled") {
        return {
            redirect: {
                destination: "/",
                permanent: false,
            },
        }
    }

    // find menu item for this page
    // const menuItem = data.site.flatmenu.find(item => item.typeHandle === "htmlPage" && item.page[0]?.slug === pageSlug)

    let pageVersion,
        version = false
    // const versionDraftIds = data.page?.versionDraftIds?.split(",")
    // if (versionDraftIds?.length) {
    //     const randomVersionIndex = Math.floor(Math.random() * (versionDraftIds.length + 1) + 1)
    //     console.log('randomVersionIndex: ' + randomVersionIndex);
    //     version = "ABCDEFGHIJKLMN"[randomVersionIndex - 1]
    //     if (randomVersionIndex > 1) {
    //         console.log(parseInt(versionDraftIds[randomVersionIndex - 2], 10));
    //         const site = getSiteByLocale(ctx.locale)
    //         pageVersion = await getPage(
    //             site.craftId,
    //             pageSlug,
    //             parseInt(versionDraftIds[randomVersionIndex - 2], 10),
    //             ctx.query.revisionId,
    //             previewToken
    //         )
    //     }
    // } else {
    ctx.res.setHeader("Cache-Control", "public, s-maxage=60, stale-while-revalidate=90")
    // }

    return {
        props: {
            section: "htmlPages",
            slug: pageSlug,
            page: pageVersion?.data || data.page,
            channels: data.site.channels,
            site: data.site,
            locale: ctx.locale,
            pageStatus: data.page.userStatus,
            user: user,
            version,
        },
    }
})
